import { render } from "./course-learning-map-student.vue?vue&type=template&id=e634c108&ts=true"
import script from "./course-learning-map-student.vue?vue&type=script&lang=ts"
export * from "./course-learning-map-student.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__